import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';  // Eye icon for viewing
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation

const ViewTOurs = () => {
  const [tours, setTours] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false); // For delete confirmation
  const [tourToDelete, setTourToDelete] = useState(null); // Store the tour ID to delete

  // Initialize useNavigate hook
  const navigate = useNavigate();

  // Fetch data from API using axios
  useEffect(() => {
    axios.get('https://genzserver.mylksystems.com/Tours/getTourHeader')
      .then((response) => {
        setTours(response.data.data); // Assuming the response has a 'data' property with the array of tours
      })
      .catch((error) => {
        console.error("There was an error fetching the tours data!", error);
      });
  }, []);

  // Filter tours based on search query
  const filteredTours = tours.filter((tour) =>
    tour.Title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Handle image click to open modal
  const handleClickOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  // Handle modal close
  const handleClose = () => {
    setOpen(false);
    setSelectedImage('');
  };

  // Handle row click to navigate to UpdateTour
  const handleUpdateClick = (tourId) => {
    navigate('/UpdateTours', { state: { TourId: tourId } }); // Pass TourId via state
  };

  // Open the delete confirmation dialog
  const handleDeleteClick = (tourId) => {
    setTourToDelete(tourId); // Store the tour ID to delete
    setConfirmDelete(true); // Open the confirmation dialog
  };

  // Close the delete confirmation dialog
  const handleCloseDelete = () => {
    setConfirmDelete(false);
    setTourToDelete(null);
  };

  // Handle deleting the tour
  const handleConfirmDelete = () => {
    if (tourToDelete) {
      // Make an API call to delete the tour
      axios.post(`https://genzserver.mylksystems.com/Tours/deleteTour`,{tourId : tourToDelete})
        .then((response) => {
          console.log(response.data);
          setTours(tours.filter((tour) => tour.TourId !== tourToDelete)); // Remove the deleted tour from the list
          handleCloseDelete();
        })
        .catch((error) => {
          console.error("Error deleting tour:", error);
          alert('Failed to delete the tour. Please try again.');
        });
    }
  };

  return (
    <div style={{ margin: '20px' }}>
      <div style={{ marginBottom: '20px', fontSize: '24px', fontWeight: 'bold' }}>
        Tours
      </div>

      {/* Search Bar */}
      <TextField
        label="Search Tours"
        variant="outlined"
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{ marginBottom: '20px', width: '300px', float: 'right' }}
      />

      {/* Material UI Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{fontWeight : 'bold'}}>Tour ID</TableCell>
              <TableCell style={{fontWeight : 'bold'}}>Title</TableCell>
              <TableCell style={{fontWeight : 'bold'}}>Description</TableCell>
              <TableCell style={{fontWeight : 'bold'}}>Duration (Days)</TableCell>
              <TableCell style={{fontWeight : 'bold'}}>Cover Image</TableCell>
              <TableCell style={{fontWeight : 'bold'}}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredTours.map((tour) => (
              <TableRow
                key={tour.TourId}
                style={{ textDecoration: 'none', cursor: 'pointer' }}
              >
                <TableCell>{tour.TourId}</TableCell>
                <TableCell>{tour.Title}</TableCell>
                <TableCell>{tour.description.length > 50 ? `${tour.description.substring(0, 50)} ...` : tour.description}</TableCell>
                <TableCell>{tour.days}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleClickOpen(`https://genzserver.mylksystems.com/Assets/Tours/${tour.Photo}`)}>
                    <VisibilityIcon />
                  </IconButton>
                </TableCell>
                <TableCell>
                  {/* Update Button */}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleUpdateClick(tour.TourId)}
                    style={{ marginRight: '10px' }}
                  >
                    Update
                  </Button>
                  {/* Delete Button */}
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => handleDeleteClick(tour.TourId)}
                  >
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog for viewing the image */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Tour Image</DialogTitle>
        <DialogContent>
          <img
            src={selectedImage}
            alt="Tour"
            style={{ width: '100%', height: 'auto' }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} style={{ margin: '0 10px', padding: '5px 15px' }}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={confirmDelete} onClose={handleCloseDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this tour?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ViewTOurs;
